export default {
  validator_number_must_8: (rule, value, callback) => {
    if (/^[0-9]{8}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为8位数字'))
    }
  },
  validator_number_must_6: (rule, value, callback) => {
    if (/^[0-9]{6}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为6位数字'))
    }
  },
  validator_number_must_4: (rule, value, callback) => {
    if (/^[0-9]{4}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为4位数字'))
    }
  },
  validator_number_must_2: (rule, value, callback) => {
    if (/^[0-9]{2}$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为2位数字'))
    }
  },
  validator_number_must: (rule, value, callback) => {
    if (/^[0-9]+$/.test(value)) {
      callback()
    } else {
      return callback(new Error('必填，且必须为数字'))
    }
  },
  validator_number_8: (rule, value, callback) => {
    if (/^[0-9]{8}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为8位数字'))
    }
  },
  validator_number_6: (rule, value, callback) => {
    if (/^[0-9]{6}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为6位数字'))
    }
  },
  validator_number_4: (rule, value, callback) => {
    if (/^[0-9]{4}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为4位数字'))
    }
  },
  validator_number_2: (rule, value, callback) => {
    if (/^[0-9]{2}$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为2位数字'))
    }
  },
  validator_number: (rule, value, callback) => {
    if (/^[0-9]+$/.test(value) || !value) {
      callback()
    } else {
      return callback(new Error('必须为数字'))
    }
  },
}